import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "n-icon-select",
  "use": "n-icon-select-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"n-icon-select\">\n    <path d=\"M8.00003 12.6983L4.64021 9.2318C4.21593 8.87824 3.58537 8.93556 3.2318 9.35984C2.87824 9.78412 2.93556 10.4147 3.35984 10.7682L7.35984 14.7682C7.73069 15.0773 8.26936 15.0773 8.64021 14.7682L16.6402 6.76825C17.0645 6.41468 17.1218 5.78412 16.7682 5.35984C16.4147 4.93556 15.7841 4.87824 15.3598 5.2318L8.00003 12.6983Z\" fill=\"currentColor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol